<template>
    <div id="recipe-details-page" class="page recipe-details">
        <div class="recipe-details__head">
            <div class="container-xl">
                <div class="row recipe-details__head-row">
                    <div class="col-12 col-md-6 recipe-details__img-wrap">
                        <div class="category-name">
                            <span v-for="(category, category_index) in currentItem.category" :key="category_index">
                                {{ category.name }}
                            </span>
                        </div>  
                        <img v-if="currentItem.image" 
                            :alt="currentItem.name" 
                            :title="currentItem.name" 
                            class="img-fluid"                         
                            sizes="(max-width: 767px) 100vw, 570px" 
                            :src="src_url + '/' + itemSrc(currentItem, 'w1140h878')"
                            :srcset="currentItem.srcset"
                        />                    
                        <!-- no-image -->
                        <img v-else 
                            src='@/assets/images/noimage/recept-no-image.svg' 
                            :alt="currentItem.name" 
                            :title="currentItem.name" 
                            class="img-fluid"
                        />                          
                    </div>
                    <div class="col-12 col-md-6 recipe-details__main-data">
                        <router-link :to="{ name:'RecipesCategoryListAll_' + currentLangName() }" class="text-link--back text-link">
                            {{ lang('vissza_a_receptek_oldalra')}}
                        </router-link>
                        <h1 data-share-title>{{ currentItem.name }}</h1>
                        
                    </div>
                    <div class="data-row">
                        <div class="making-time" v-if="currentItem.making_time">
                            <div>
                                <span class="title">{{lang('recept_elkeszitesi_ido')}}</span>
                                <span>{{ currentItem.making_time }}</span>
                            </div>
                        </div>
                        <div class="dish" v-if="currentItem.dish">
                            <div>
                                <span class="title">{{lang('recept_fogas')}}</span>
                                <span>{{ currentItem.dish }}</span>
                            </div>
                        </div>
                        <div class="difficulty" v-if=" currentItem.difficulty">
                            <div>
                                <span class="title">{{lang('recept_nehezseg')}}</span>
                                <span>{{ currentItem.difficulty }}</span>
                            </div>
                        </div>
                        <div class="calories" v-if="currentItem.calorie">
                            <div>
                                <span class="title">{{lang('recept_kaloria')}}</span>
                                <span>{{currentItem.calorie}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container-xl">
            <div class="row recipe-details__content">               
                <div class="col-12 col-md-8 col-lg-9 recipe-details__desc-wrap">                    
                    <div class="recipe-details__desc-wrap--inner">
                        <div class="recipe-details__short-desc" v-if="currentItem.short_description">
                            {{ currentItem.short_description }}
                        </div>
                        <div class="recipe-details__desc details-page-desc" v-if="currentItem.description" v-html="currentItem.description">
                            {{ currentItem.description }}
                        </div>                     
                        <div class="recipe-details__related-products" v-if="relatedProducts.length > 0">
                            <h4>{{ lang('recepthez_ajanlott_termekeink')}}</h4>
                            <div class="carousel-outer-wrap">
                                <div class="carousel-wrap">            
                                    <carousel v-if="relatedProducts.length > 0"  :items="4" :margin="30" :autoWidth="true" :dots="false"  :loop="false" :responsive="{ 
                                                    0:{
                                                        items:1,
                                                        autoWidth: true,
                                                        margin: 20,
                                                        mouseDrag: true,                                 
                                                        nav: false},      
                                                    576:{items:2, mouseDrag:true, nav:false, margin: 20},
                                                    768:{items:3, mouseDrag:true, margin: 20},                            
                                                    992:{items:3, mouseDrag:false},
                                                    1200:{items:4, mouseDrag:false}                            
                                        }">                                    
                                            
                                            <ProductItem v-for="fProduct in relatedProducts" 
                                                :key="fProduct.id" 
                                                :name="fProduct.name"                         
                                                :product_slug="fProduct.slug" 
                                                :srcset="itemSrcset(fProduct)" :src="itemSrc(fProduct, 'w286h440')" 
                                                :id="fProduct.id"
                                            />                        
                                    </carousel>            
                                </div>  
                            </div>   
                        </div> 
                        <div class="social-share-row">
                            <SocialShare />
                        </div> 
                    </div>                                   
                </div>                                
                <div class="col-12 col-md-4 col-lg-3  recipe-details__related-recipes-wrap">                    
                    <div class="recipe-details__related-recipes" v-if="relatedRecipes.length > 0">                        
                        <h4>{{ lang('kapcsolodo_receptek') }}</h4>
                        <RecipeItem   v-for="recipe in relatedRecipes" :key="recipe.id"
                            :name="recipe.name"
                            :id="recipe.id"                                  
                            :recipe_slug="recipe.slug" 
                            :srcset="itemSrcset(recipe)" 
                            :src="itemSrc(recipe, 'w640h493')" 
                            :difficulty="recipe.difficulty"
                            :dish="recipe.dish"
                            :making_time="recipe.making_time" 
                        />  
                        <router-link :to="{name: 'RecipesCategoryListAll_'+ currentLangName()}" class="btn btn--primary"><span>{{ lang("osszes_recept_megtekintese")}}</span></router-link>
                        </div>                                   
                </div>                    
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import RecipeItem from '@/components/pagesComponents/recipes/RecipeItem.vue'
import ProductItem from '@/components/pagesComponents/products/ProductItem.vue'
import carousel from 'vue-owl-carousel'
import SocialShare from '@/components/layoutComponents/SocialShare.vue'

export default {
    data(){
        return{
            currentItem: {},
            // currentItemtId: null,
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME,
            relatedRecipes: [],
            relatedProducts: [],
            metaImg: {
                src: null                
            }                    
        }
    },
    components:{
        RecipeItem,
        ProductItem,
        carousel,
        SocialShare
    },
    computed:{        
        currentItemtSlug(){
            return this.$route.params.recipe_slug;
        }            
    },
    watch:{
        currentItemtSlug: function(){
            this.relatedRecipes = [],
            this.relatedProducts = []  
            this.getCurrentItemData();
        },        
    },
    methods:{
        getCurrentItemData(){   
            let _this = this                                          

            axios.get(process.env.VUE_APP_BIFROST_API_URL + '/information/'+ this.currentItemtSlug + '?relations=1&relations_params[information][where][0][0]=where&relations_params[information][where][0][1]=status&relations_params[information][where][0][2]=1&relations_params[information][order_by][0][0]=sort_order&relations_params[information][order_by][0][1]=asc'  ,{
                params:{
                    "language_id": this.$store.getters.getSelectedLang.id                         
                }
            }).then(response => {                
                if (response.data.status == true) {
                    if ( parseInt(response.data.information[0].status) === 1 ) {
                        this.currentItem = response.data.information[0]  
                        if (response.data.information[0].information){
                            this.getRelatedData()
                        } else {
                            this.relatedProducts = []
                            this.relatedRecipes = []
                        }

                        if ( !response.data.information[0].meta_image ) {                              
                            _this.metaImg = null
                        } else {                            
                            let meta_image_src = process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME + '/' + response.data.information[0].meta_image.path + response.data.information[0].meta_image.file_name
                            _this.metaImg = meta_image_src
                        }
                        this.setCurrentMetaTags()
                    } else {
                        this.$router.push({name: '404-page'})
                    }
                   
                } else {
                    this.$router.push({name: '404-page'})
                }
                                                                              
            })
            .catch((err) => {
                console.log(err)
            });             
            
        },
        getRelatedData(){
            let _this = this;

            this.currentItem.information.forEach(element => {
                if (element.type == 'product'){
                    _this.relatedProducts.push(element)
                } else if ( element.type == 'recipe'){
                    _this.relatedRecipes.push(element)
                }
            });
        },
        setCurrentMetaTags(){
            let _this = this            

            this.setMetaTags({
                title: _this.currentItem.meta_title, 
                desc: _this.currentItem.meta_description, 
                keywords: _this.currentItem.meta_keywords, 
                ogType: 'article', 
                ogTitle: _this.currentItem.meta_title,
                ogImage: _this.metaImg, 
                ogImageWidth: null, 
                ogImageHeight: null, 
                ogDesc: _this.currentItem.meta_description
            })
        }
            
    },
    created(){
        this.getCurrentItemData();
    },

}
</script>